import Vue from 'vue'
import { login, logout, phoneLogin } from "@/api/login"
import { ACCESS_TOKEN, USER_NAME, USER_INFO, USER_AUTH, SYS_BUTTON_AUTH } from "@/store/mutation-types"
import { welcome } from "@/utils/util"
import { queryPermissionsByUser,queryMapContent,getTenantInfo } from '@/api/api'
const getMenu = function (arr) {

  let arrs = []
  let arrData = JSON.parse(JSON.stringify(arr))
  arrData.forEach((item1, index1) => {
    if (!item1.hidden) {
      if (item1.children && item1.children.length > 0) {
        item1.children = getMenu(item1.children)
      }

      if (item1.children && item1.children.length <= 0) delete item1.children
      arrs.push(item1)
    }
  })
  return arrs
}
const user = {
  state: {
    token: '',
    username: '',
    realname: '',
    welcome: '',
    avatar: '',
    permissionList: [],
    info: {},
    tenantInfo:{},
    bgColor: '#1890ff'
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_BGCOLOR: (state, bgColor) => {
      state.bgColor = bgColor
    },
    SET_NAME: (state, { username, realname, welcome }) => {
      state.username = username
      state.realname = realname
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_TENANT_INFO: (state, info) => {
      state.tenantInfo = info
    }
  },

  actions: {
    // 初始化租户信息
    initTenantInfo({ commit }) {
      return new Promise((resolve, reject) => {
        let tenantId = window.localStorage.getItem('tenant')
        if(!tenantId){
          reject('tenantId is empty')
          return
        }
        getTenantInfo(window.localStorage.getItem('tenant')).then(response => {
          if (response.success) {
            const result = response.result
            commit('SET_TENANT_INFO', result)
            resolve(result)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    Login({ commit,dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        Vue.ls.remove(ACCESS_TOKEN)
        login(userInfo).then(response => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            dispatch('getMapData')

            window.sessionStorage.setItem('token', result.token)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    wechatLogin({ commit }, response) {
      return new Promise((resolve, reject) => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)

            window.sessionStorage.setItem('token', result.token)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
    },
    //手机号登录
    PhoneLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        phoneLogin(userInfo).then(response => {
          if (response.code == '200') {
            const result = response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetPermissionList({ commit }) {
      return new Promise((resolve, reject) => {
        let v_token = Vue.ls.get(ACCESS_TOKEN);
        let params = { token: v_token };
        queryPermissionsByUser(params).then(response => {
          const menuData = getMenu(response.result.menu)
          const authData = response.result.auth;
          const allAuthData = response.result.allAuth;
          //Vue.ls.set(USER_AUTH,authData);
          sessionStorage.setItem(USER_AUTH, JSON.stringify(authData));
          sessionStorage.setItem(SYS_BUTTON_AUTH, JSON.stringify(allAuthData));
          if (menuData && menuData.length > 0) {
            commit('SET_PERMISSIONLIST', menuData)
          } else {
            reject('getPermissionList: permissions must be a non-null array !')
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        let logoutToken = state.token;
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONLIST', [])
        Vue.ls.remove(ACCESS_TOKEN)
        sessionStorage.removeItem('siteId')
        sessionStorage.removeItem('siteType')
        sessionStorage.removeItem('fullName')
        sessionStorage.removeItem('siteName')
        sessionStorage.removeItem('treeCategory')
        sessionStorage.removeItem('siteAreaName')
        sessionStorage.removeItem('siteAreaId')
        localStorage.removeItem('treeSt')
        // 清理因子选择的固定本地缓存
        localStorage.removeItem('waste_water_legend_selected')

        logout(logoutToken).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },
    ChangeColor({ commit, state }, color) {
      commit('SET_BGCOLOR', color)
    },
    getMapData(){
      console.log('&Vue.ls.get(USER_INFO)',Vue.ls.get(USER_INFO))
      if(Vue.ls.get(ACCESS_TOKEN)&&Vue.ls.get(USER_INFO)){
        queryMapContent(Vue.ls.get(USER_INFO).id).then(res=>{
          if(res.success){
            res.result.forEach(item=>{
              switch (item.code){
                case 'center_zoom':
                  if(item.val){
                    localStorage.setItem('mapCenter',item.val)
                  }else{
                    // 没获取到取当前租户下的缓存
                    if(localStorage.getItem('tenantMapCenter')){
                      localStorage.setItem('mapCenter',localStorage.getItem('tenantMapCenter'))
                    }
                  }
                  break;
                case 'zoom_level':
                  if(item.val){
                    localStorage.setItem('mapZoom',item.val)
                  }else{
                    // 没获取到取当前租户下的缓存
                    if(localStorage.getItem('tenantMapZoom')){
                      localStorage.setItem('mapZoom',localStorage.getItem('tenantMapZoom'))
                    }
                  }
                  break;
              }
            })
          }
        })
      }
    }
  }
}

export default user